import React, { useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import styled from "styled-components";
import { Button } from "semantic-ui-react";
import { permissions } from "../../constant/permissions";
import {
  deleteBoardPost,
  fetchBoardPosts,
} from "../../redux/modules/board-post";
import { RoleRequired } from "../auth/role-required";
import { PostList, PAGE_SIZE } from "./list";
import { PostForm } from "./post-form";
import { t } from "../../constant/translations";
import { StyledLabel } from "../../components/common/page-navigation";

const StyledController = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  flex-shrink: 0;
`;

const ControlRight = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const SectionTitle = styled.div`
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #a8a29e;
`;

const StyledNoMessage = styled.div`
  padding: 20px 0;
  font-size: 13px;
  color: #a8a29e;
  text-align: center;
`;

export const Board = (props) => {
  const { block, posts, canEdit } = props;
  const hasPosts = posts && posts.length !== 0;
  const sorted = [...posts].sort((a, b) =>
    a.created_at > b.created_at ? -1 : 1
  );
  const [page, setPage] = useState(0);
  const totalPages = Math.ceil(sorted.length / PAGE_SIZE);

  return (
    <>
      <StyledController>
        <SectionTitle>{t("board.messages")}</SectionTitle>
        <ControlRight>
          {totalPages > 1 && (
            <div>
              <Button
                disabled={page === 0}
                basic
                size="tiny"
                icon="angle double left"
                onClick={() => setPage(0)}
              />
              <Button
                disabled={page === 0}
                basic
                size="tiny"
                icon="angle left"
                onClick={() => setPage((p) => p - 1)}
              />
              <StyledLabel>{`${page + 1}/${totalPages}`}</StyledLabel>
              <Button
                disabled={page >= totalPages - 1}
                basic
                size="tiny"
                icon="angle right"
                onClick={() => setPage((p) => p + 1)}
              />
            </div>
          )}
          <RoleRequired staff={true} permission={permissions.boardEditPost}>
            <PostForm
              initialData={{ block: block.id, files: [] }}
              header={t("board.new_message")}
              triggerElement={
                <Button primary size="tiny">
                  <i className="plus icon" />
                  {t("board.new_message")}
                </Button>
              }
            />
          </RoleRequired>
        </ControlRight>
      </StyledController>

      {!hasPosts && <StyledNoMessage>{t("board.no_new_msg")}</StyledNoMessage>}
      <PostList posts={sorted} canEdit={canEdit} page={page} />
    </>
  );
};

function mapState(state) {
  return {
    posts: state.boardpost.entities || [],
    canEdit: state.auth.user?.hasPermission(permissions.boardEditPost),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ deleteBoardPost, fetchBoardPosts }, dispatch);
}

export default connect(mapState, mapDispatchToProps)(Board);
